import { Route, RouteObject } from "react-router-dom";
import ServiceLandingPage from "./components/landing/landing";
import { CreateServiceRequest, ServiceRequestDetail } from "./components";
import ServiceRequestSuccessPage from "./components/receipt/receipt";

export interface serviceRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: serviceRoute[];
}

export const serviceRoutes: serviceRoute[] = [
  {
    path: "cx/services",
    element: <ServiceLandingPage />,
  },
  {
    path: "cx/services/create",
    element: <CreateServiceRequest />,
  },
  {
    path: "cx/services/current/:id",
    element: <ServiceRequestDetail />,
  },
  {
    path: "cx/services/history/:id",
    element: <ServiceRequestDetail />,
  },
  {
    path: "cx/services/success",
    element: <ServiceRequestSuccessPage />,
  },
];
